import { endUserSession } from "@/services/API";
import { LeftNavItem } from "./LefthandGlobalNavItem";
import { NavigationIcon, NavigationId, NavigationType } from "@/enums";

//the logo should direct back to the teacher home screen, which is at /dashboard
export const lefthandNavItemsAdmin: Array<LeftNavItem> = [
    {
        type: NavigationType.LINK_INTERNAL,
        displayName: "Home",
        idName: NavigationId.DASHBOARD,
        route: "/dashboard",
        icon: NavigationIcon.DASHBOARD,
        sequenceNum: 5
    },
    {
        type: NavigationType.LINK_INTERNAL,
        displayName: "Reports",
        idName: NavigationId.REPORTS,
        route: "/teacher/reports",
        icon: NavigationIcon.REPORTS,
        sequenceNum: 10
    },
    {
        type: NavigationType.BUTTON,
        displayName: "Logout",
        idName: NavigationId.LOGOUT,
        route: "",
        icon: NavigationIcon.LOGOUT,
        sequenceNum: 50, 
        action: () => {
            sessionStorage.removeItem('onboardingDismissedThisSession');
            endUserSession();
        }
    }
];

export const lefthandNavItemsGeneral: Array<LeftNavItem> = [
    {
        type: NavigationType.LINK_INTERNAL,
        displayName: "Home",
        idName: NavigationId.DASHBOARD,
        route: "/dashboard",
        icon: NavigationIcon.DASHBOARD,
        sequenceNum: 5
    },
    {
        type: NavigationType.LINK_INTERNAL,
        displayName: "Reports",
        idName: NavigationId.REPORTS,
        route: "/teacher/reports",
        icon: NavigationIcon.REPORTS,
        sequenceNum: 10
    },
    {
        type: NavigationType.LINK_INTERNAL,
        displayName: "Settings",
        idName: NavigationId.SETTINGS,
        route: "/settings",
        icon: NavigationIcon.SETTINGS,
        sequenceNum: 20
    },
    {
        type: NavigationType.BUTTON,
        displayName: "Logout",
        idName: NavigationId.LOGOUT,
        route: "",
        icon: NavigationIcon.LOGOUT,
        sequenceNum: 40, 
        action: () => {
            endUserSession();
        }
    }
];